import { Money } from '@klear/money'
import { toCurrencyCode } from '@klear/money/currency'
import type { CurrencyCode } from '@klear/constants/currency'
import isString from 'lodash/isString'

export function moneyFromFormValue(value: unknown): Money | undefined {
  if (value instanceof Money) return value
  if (!isString(value) || value.trim() === '') return undefined
  try {
    return new Money(value)
  } catch {
    return undefined
  }
}

const MINOR_DIGITS_PATTERN = /^-?\d+$/

export function moneyFromMinorDigits(minor: string, currency: CurrencyCode | string): Money {
  const trimmed = minor.trim()
  if (!MINOR_DIGITS_PATTERN.test(trimmed)) {
    throw new Error(`Invalid minor money amount: ${JSON.stringify(minor)} is not a decimal integer of minor units.`)
  }
  return Money.fromMinorUnits(BigInt(trimmed), toCurrencyCode(currency))
}
